import { render, staticRenderFns } from "./Recepcionista.vue?vue&type=template&id=600d3c9b&scoped=true"
import script from "./Recepcionista.vue?vue&type=script&lang=js"
export * from "./Recepcionista.vue?vue&type=script&lang=js"
import style0 from "./Recepcionista.vue?vue&type=style&index=0&id=600d3c9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d3c9b",
  null
  
)

export default component.exports